import { render, staticRenderFns } from "./StaffTools.vue?vue&type=template&id=0b7e0d50&scoped=true"
import script from "./StaffTools.vue?vue&type=script&lang=js"
export * from "./StaffTools.vue?vue&type=script&lang=js"
import style0 from "./StaffTools.vue?vue&type=style&index=0&id=0b7e0d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7e0d50",
  null
  
)

export default component.exports